export default {
  // 通用
  cancel: "Cancelar",
  save: "Guardar",
  sure: "Aceitar",
  state: "Estado",
  operation: "Operação",
  prompt: "Pronto",
  pleaseChoose: "Por favor escolha",
  updateSuccess: "Atualização com sucesso",
  closeAccountSuccess: "Fechar conta com sucesso",
  email: "E-mail",
  customerId: "Identificação do Cliente",
  sureDelete: "Tem certeza de que deseja apagar?",
  deleteSuccess: "Apagado com sucesso",
  addSuccess: "Adicionado com sucesso",
  saveSuccess: "Guardado com sucesso",
  operateSuccess: "Operação bem sucedida",
  message: "Mensagem",
  refresh: "Atualizar",
  yes: "Sim",
  no: "Não",
  import: "Importar",
  importFilesuccess: "Arquivo importado com sucesso",
  exportFilesuccess: "Arquivo exportado com sucesso",
  export: "Exportar",
  browse: "Navegador",
  home: "Casa",
  copySuccess: "Replicado com sucesso",
  pleaseInput: "Por favor, insira",
  emailError: "O formato do e-mail está incorreto",
  unSavedWarning: "Você tem dados não guardados, guarde e adicione",
  editUnSavedWarning: "Grava primeiro o item de edição actual",
  loadMore: "Clique para carregar mais",
  noData: "Sem dados",
  noMoreData: "Sem mais dados",
  delete: "Apagar",
  copy: "Copiar",
  edit: "Editar",
  pleaseChooseData: "Selecione os dados a guardar",
  total: "Total",
  exportPanel: "Exportar para a central",
  importPanel: "Importar do painel",
  salesChannel: "Canal de vendas",
  lastLoginDate: "Última data de inicio de sessão",
  globalLoadingText:
    "Esta operação pode levar vários minutos para ser processada ...",
  globalLoading: "Carregando",
  all: "Todas",
  empty: "VAZIO",
  notEmpty: "NÃO ESTÁ VAZIO",
  version: "Versão",
  logo: "logotipo",
  help: "Ajuda",
  // 注册时的滑块组件
  swipeRight: "Deslize para a direita para preencher o puzzle",
  // 登录
  account: "Conta",
  accountEmpty: "A conta não pode estar vazia",
  confirmPassword: "Confirme a palavra passe",
  customerIdCode: "Código de identificação do cliente",
  customerName: "Nome do cliente",
  forgotPassword: "Esqueceu a palavra passe?",
  sureResetPassword: "Tem certeza de que deseja redefinir a sua palavra passe?",
  loginCheck: "A conta ou a palavra passe não podem estar vazias",
  optionalInformation: "Informação opcional",
  password: "Palavra passe",
  register: "Registar",
  rememberMe: "Recorde-me",
  systemName: "Ferramenta de Configuração",
  signIn: "Registar-se",
  signOutPrompt: "Tem certeza de que deseja sair do sistema?",
  nameEmpty: "O nome não pode estar vazio",
  passwordEmpty: "A palavra passe não pode estar vazia",
  confirmPasswordEmpty: "A palavra passe de confirmação não pode estar vazia",
  phoneEmpty: "O telefone não pode estar vazio",
  emailEmpty: "O e-mail não pode estar vazio",
  registerSuccess:
    "Verifique o seu e-mail para continuar com o processo de registo",
  tryAgain: "Por favor, tente novamente",
  unagree: "Marque para concordar com os termos e condições",
  // resetPasswordSuccess: 'Password reset successfully, please go to email to confirm',
  resetPasswordSuccess:
    "Se o nome de utilizador corresponder aos nossos registos, será enviado um e-mail de redefinição de palavra passe",
  notModified: "Você não o modificou",
  unsavedRemind: "Você tem alterações não confrmadas. Você quer guarda-las?",
  identityInvalid:
    "A informação de identidade é inválida, faça login novamente",
  // 配置文件
  createNewConfigFile: "Crie um novo arquivo de configuração",
  createNewProject: "Crie um novo projeto",
  openExistingProject: "Abrir projeto existente",
  loadConfigFile: "Carregar um arquivo de configuração existente",
  // 顶部head
  userInfo: "Informação de utilizador",
  changePassword: "Alterar palavra passe",
  myProjects: "Meus projetos",
  accountManagement: "Administração de contas",
  signOut: "Sair",
  // 修改密码
  currentPassword: "Palavra passe atual",
  newPassword: "Nova palavra passe",
  confirmNewPassword: "Confirme a nova palavra passe",
  checkCurrentPwd: "A palavra passe atual não pode estar vazia",
  checkNewPwd: "A nova palavra passe não pode estar vazia",
  checkConfirm: "A confirmação da nova palavra passe não pode estar vazia",
  checkConfirmSame:
    "A palavra passe de confirmação não é a mesma que a nova palavra passe",
  currentNewPasswordCheck:
    "A nova palavra passe não pode ser igual à palavra passe atual",
  changePwdSuccess: "Palavra passe alterada com sucesso",
  // 个人信息
  name: "Nome",
  language: "Língua",
  emailAddress: "Endereço de e-mail",
  phone: "telefone",
  closeAccount: "Fechar conta",
  closeAccountPermanently:
    "Elimina permanentemente as informações da conta e os dados dos serviços.",
  closeAccountPermanentlyAll:
    "Fechar a sua conta, vai apagar permanentemente todas as suas informações e você não poderá mais usar nenhum dos serviços.",
  // 项目信息
  projectDialogNew: "Informações do Projeto",
  projectDialogEdit: "Editar projeto",
  projectName: "Nome",
  projectSite: "Nome do Projeto",
  projectNote: "Nota",
  projectPanelsList: "Central",
  projectPanelMode: "Modo o Painel",
  projectPanelTypeSingle: "stand-alone",
  projectPanelTypeNetwork: "rede",
  projectPaneNo: "ID",
  projectPaneNote: "Descrição",
  projectNewSuccess: "Criado com sucesso",
  editTableError: "Guarde a tabela editada",
  myProjectDialog: "Meus projetos",
  projectTablesite: "Nome do Projeto",
  projectTablepanelsNumber: "NÚMERO DE PAINÉIS",
  projectTablecreatedTime: "DATA DE CRIAÇÃO",
  projectTablemodifyTime: "DATA DA ÚLTIMA EDIÇÃO",
  projectTablenotes: "NOTAS",
  projectTableDelete: "Apagado com sucesso",
  projectEditSuccess: "Atualização com sucesso",
  projectTableCopy: "Copiar com sucesso",
  projectTableEdit: "Editar projeto",
  projectTableDown: "Descarregado com sucesso",
  projectTablePanelWarning: "Número de centrais",
  projectLeadTitle: "Importar arquivo",
  projectLeadRowName: "Selecione o arquivo",
  projectLeadRowButtom: "Upload",
  projectLeadRowButtomselectBefore: "Selecione",
  folderLeadSuccess: "Importação de pasta com sucesso",
  projectLeadSuccess: "Importação de projeto com sucesso",
  projectAddRequired: "Os elementos obrigatórios estão incompletos",
  projectSelectPanels: "Selecionar central",
  projectInfoPanelTheadPanelNo: "CENTRAL NO.",
  projectInfoPanelTheaddesc: "Descrição",
  projectInfoPanelsWarning: "Nenhuma central selecionada",
  panelDetail: "Detalhes da central",
  panelAddSuccess: "Adicionar o Painel com sucesso",
  panelUpdateSuccess: "Actualizar o Painel com êxito",
  panelDeleteSuccess: "Apagar o Painel com êxito",
  // 账号管理
  disable: "Cancelado",
  disabled: "Desativado",
  enable: "Habilitar",
  enabled: "Habilitado",
  activate: "Ativar",
  activated: "Ativado",
  inactivated: "Inativado",
  disabledSuccess: "Desativado com sucesso",
  activateSuccess: "Ativado com sucesso",
  enabledSuccess: "Habilitado com sucesso",
  // 子菜单
  readonlyInformation: "Histórico da central",
  deviceTable: "Dispositivos de loop",
  zoneDelays: "Atraso SND + FR de zona",
  daynightSchedule: "Configurações de dia / noite",
  advancedProgramming: "Programação avançada",
  systemSettings: "Configurações do sistema",
  myDownload: "Minhas descargas",
  // 设备
  loop: "Loop",
  channel: "canal",
  address: "Endereço",
  type: "Tipo",
  description: "Descrição",
  zone: "Zona",
  group: "Grupo",
  sensitivityDuringProfileL1: "Sensibilidade durante o perfil L1",
  sensitivityDuringProfileL2: "Sensibilidade durante o perfil L2",
  sensitivityDuringProfileL3: "Sensibilidade durante o perfil L3",
  deviceExportSuccess:
    "Exportação bem-sucedida. Faça download em 'Minhas descargas '",
  // sensitivityTips: 'Sensitivity tips',
  // profile: 'Profile',
  // sensitivitySmoke: 'Sensitivity smoke',
  // 校验规则
  outOfRange: "Os números estão fora do alcance",
  tooLong: "Demasiados caracteres",
  // Zone SDN+FR delays
  activeSNDByDET: "Ativar SND para DET",
  doesSNDDelayApplyToDETAlarms: "Aplicar atraso SND para DET",
  SNDDelay: "Atraso SND (s)",
  activeSNDByMCP: "Ativar SND para MCP",
  doesSNDDelayApplyToMCPAlarms: "Aplicar atraso SND para MCP",
  activeFRByDET: "Ativar FR para DET", //
  doesFRDelayApplyToDETAlarms: "Aplicar atraso FR para DET",
  FRDelay: "Atraso FR (s)",
  activeFRByMCP: "Ativar FR para MCP",
  doesFRDelayApplyToMCPAlarms: "Aplicar atraso FR para MCP",
  resoundSoundersIfNewZoneInAlarm: "Ressonar as sirenes se nova zona em alarme",
  // schedule
  week: "Semana",
  dayStart: "Início Diurno (Ativar atrasos neste horário)",
  sensitivityProfileDuringDay: "Perfil de sensibilidade durante o dia",
  nightStart: "Início Noturno (Desabilitar atrasos neste horário)",
  sensitivityProfileDuringNight: "Perfil de sensibilidade durante a noite",
  monday: "Segunda-feira",
  tuesday: "Terça-feira",
  wednesday: "Quarta feira",
  thursday: "Quinta feira",
  friday: "Sexta-feira",
  saturday: "Sábado",
  sunday: "Domingo",
  notSet: "NÃO ESTABELECIDO",
  // 编码
  actionNumber: "Número de ação",
  scenario: "Cenário",
  activation: "Ativação",
  line: "Linha",
  alarmType: "Tipo de alarme",
  quantityOfAlarms: "Quantidade de alarmes",
  groupToActivate: "Grupo para ativar",
  combination: "Combinação",
  delay: "Atraso",
  hold: "PULSO? (MAX 63 s; 0-> NÃO)",
  twoStages: "Duas Etapas",
  twoStagesVersionTip:
    "Este recurso requer software do controlador versão 0.6.10 ou superior",
  actionNumLimit: "O número da ação não pode exceder 400 linhas!",
  scenarioLimit: "Não pode exceder 32 linhas!",
  activationLimit: "Não pode exceder 16 linhas!",
  // system setting
  maintenanceCompanyDetails: "Detalhes da empresa de manutenção",
  company: "Empresa",
  telephone: "Telefone",
  projectName: "Nome do Projeto",
  personOfContact: "Pessoa de contato",
  setLanguage: "Definir linguagem",
  loopClass: "Classe de loop",
  setPassword: "Configurar palavra passe",
  setupPrinter: "Configurar impressora",
  systemConfiguration: "Configuração do sistema",
  notes: "Notes",
  classB: "Classe B",
  classA: "Classe A",
  off: "off",
  on: "on",
  operatorPassword: "Palavra passe do operador",
  installerPassword: "Palavra passe do instalador",
  power: "Alimentação",
  mode: "Modo",
  eventsPrinted: "Impressão de eventos",
  systemLoopCard: "# de cartas de loop no sistema",
  loopsInTheSystem: "# de loops no sistema",
  LEDPanels: "# cartas de LED",
  chargerCards: "# carregador de bateria",
  systemBoards: "# número da placas IO no sistema",
  systemNetwork: "# número da placa de rede no sistema",
  twoStagesOAT: "Tempo de acesso do operador (s)",
  twoStagesIDT: "Tempo de investigação (s)",
  mark: "Região",
  user: "Utilizador",
  time: "Hora",
  // information-info
  timeAndDateTheConfig: "Hora e data em que a configuração foi guardada",
  serialNumber: "Número de série",
  firmwareVersions: "Versões de firmware",
  dateOfLastConfig: "Data da última mudança de configuração no painel",
  eventLog: "Registo de eventos",
  operatorPasswordCheck: "A palavra passe do operador não tem 3 dígitos",
  installerPasswordCheck: "A palavra passe do instalador não tem 10 dígitos",
  // zone-setting
  zoneSettings: "Configurações de zona",
  zoneGroupTable: "Tabela de zona / grupo",
  //silenceableGroup
  silenceableGroup: "Grupo Silenceable",
  configureNetwork: "Configurar a informação da rede",
  networkingInformation: "informação em rede",
  localAddr: "Endereço Local",
  networkMode: "Modo de Rede",
  networkClass: "Classe de Rede",
  dataTransferDevice: "Dispositivo de transferência de dados",
  sendFilter: "Enviar o filtro",
  send: "enviar",
  doNotSend: "não enviar",
  Alarm: "Alarme",
  Fault: "Falha",
  Disable: "Cancelado",
  Reset: "Reset",
  Silence: "Silêncio",
  Time: "Tempo",
  Delay: "Demora",
  sendNetMap: "Definir o Mapa da Rede",
  startAddr: "Endereço inicial",
  endAddr: "Endereço final",
  acceptanceFiltering: "Filtragem de aceitação",
  reception: "recepção",
  noReception: "Sem recepção",
  addressCheck: "O endereço inicial não pode ser maior do que o endereço final",
  notDataFill: "Dados não preenchidos",
  //setIoCard
  setIoCard: "Configurar o cartão IO",
  IOBoard: "Cartão IO",
  Func: "Func",
  allowedMaxLoad: "Carga máxima permitida",
  FaultCheck: "Avarias",
  none: "nenhum",
  Output: "Saída",
  Feedback: "Confirmação",
  RTFAULT: "RT falência",
  groupBySndCK: "Ativar grupo por chave de controlo SND",
  // my download
  filename: "Nome do arquivo",
  status: "Estado",
  startTime: "Hora de início",
  endTime: "Hora final",
  download: "Descarregar",
  inExport: "Na exportação",
  success: "Sucesso",
  failure: "Falha",
  templateFile: "Arquivo de modelo",
  importDeviceMsg: "Importar uma tabela de dispositivos existente",
  importZoneDelays: "Importar um conjunto de atrasos de zona existentes",
  importAdvance:
    "Importar uma programação avançada existente, incluir ação, cenário e ativação",
  // register success
  successAccoutRequest: "Solicitação de conta bem-sucedida!",
  accountAdministrator:
    "O seu pedido foi enviado ao nosso gerente de conta (pessoa).",
  approvalApplication: "Sua conta ficará ativa após aprovarmos o seu pedido.",
  passwordResetSuccess: "Redefinição de senha bem-sucedida!",
  resetSuccessful: "Reinicialização bem-sucedida, a palavra passe é 12345678",
  dayTitle: "Perfis de sensibilidade: L1 = Dia L2 = Noite L3 = Especial",
  creationTime: "Criar tempo",
  search: "pesquisa",
  limits: "Conceda acesso à conta de suporte da Jade Bird",
  content:
    "O serviço de atenção ao cliente ahora tiene acesso a los detalhes de sua cuenta durante 14 dias. Passe revocar el permiso en cualquier momento presionando el botón nuevamente, poniéndolo en estado inativo.",
  contentLast:
    "Le recomendamos que se asegure de que esta opção esté habilitada cada vez antes de llamar a nuestra linea de soporte.",
  apply: "aplicar",
  Successful: "Aplicação bem sucedida",
  msg: "Último tempo de aplicação:",
  userName: "nome do utilizador",
  applicationTime: "Tempo de Suporte",
  showAll: "mostrar todos os projetos",
  to: "a",
  startDate: "Data de início",
  endDate: "Data final",
  porjectMsg: "Digite a palavra-chave",
  stateApply: "Estado de apoio",
  statusApply: "habilitar"
};
